import { WidgetBase } from "./WidgetBase";
import { WidgetTypes } from "./WidgetTypes";
import { WidgetController } from "../WidgetController";
import { WidgetWhoIsOnlineComponent } from "../Components/WidgetWhoIsOnlineComponent";
import { PopupWhoIsOnlineComponent } from "../Popups/PopupWhoIsOnlineComponent";
import { LanguageString } from "../../../Model/LanguageString";

export class WidgetWhoIsOnlineProps {
    public title: LanguageString;

    constructor() {
        this.title = new LanguageString();
    }
}

export class WidgetWhoIsOnline extends WidgetBase {
    props: WidgetWhoIsOnlineProps;

    constructor(controller: WidgetController) {
        super(controller, 1, 1);
        this.props = new WidgetWhoIsOnlineProps();
    }

    getType(): WidgetTypes {
        return WidgetTypes.WhoIsOnline;
    }

    loadProps(jsonProps: string): void {
        if (jsonProps && jsonProps.length > 0) {
            this.props = JSON.parse(jsonProps);

            if (this.props.title == null)
                this.props.title = new LanguageString();
        } else
            this.props.title = new LanguageString();
    }

    saveProps(): string {
        return JSON.stringify(this.props);
    }

    createComponent(column: number, row: number, colSpan?: number, rowSpan?: number): HTMLElement {
        this.column = column;
        this.row = row;
        this.colSpan = colSpan ? colSpan : this.minColSpan;
        this.rowSpan = rowSpan ? rowSpan : this.minRowSpan;
        this.component = new WidgetWhoIsOnlineComponent({
            widget: this,
            title: this.props.title
        });
        return this.component.render();
    }

    showPopup(): void {
        let popup = new PopupWhoIsOnlineComponent({ widget: this });
        document.body.appendChild(popup.render());
    }
}